import { Component } from "vue";

export default [
  { path: "", redirect: { name: "transactionList" }, name: "transactions" },
  {
    path: "list",
    component: (): Promise<Component> =>
      import("../components/TransactionList.vue"),
    name: "transactionList",
  },
  {
    path: ":uuid",
    component: (): Promise<Component> =>
      import("../components/TransactionDetails.vue"),
    name: "transactionDetails",
  },
];
